<template>
  <v-text-field
    :id="id"
    v-model="getValue"
    :outlined="outlined"
    :color="color"
    v-bind="$attrs"
    @blur="setValue($event)"
    @keypress.native.enter="setValue($event)"
  />
</template>

<script>
import VuetifyOverwriteMixin from 'Arch/components/global-components/VuetifyOverwriteMixin';

export default {
  name: 'InputText',
  mixins: [VuetifyOverwriteMixin],
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(v) {
        return v;
      },
    },
    setValue() {
      return (ev) => {
        const { value } = ev.target;
        this.$emit('input', value);
        this.$emit('blur', ev);
      };
    },
  },
};
</script>
